var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { http } from "../client";
import qs from "query-string";
import { mapCatalogTrackObject } from "../tracks/map";
import { mapBooleanToInt } from "../../lib/boolean-to-int";
var index = function (request) {
    return http.api
        .get("rightholder-earnings", {
        params: {
            start_date: request === null || request === void 0 ? void 0 : request.startDate,
            end_date: request === null || request === void 0 ? void 0 : request.endDate,
            rightholder_id: request === null || request === void 0 ? void 0 : request.rightholderId,
            mine: typeof (request === null || request === void 0 ? void 0 : request.mine) === "boolean"
                ? mapBooleanToInt(request === null || request === void 0 ? void 0 : request.mine)
                : void 0,
            is_paid: typeof (request === null || request === void 0 ? void 0 : request.isPaid) === "boolean"
                ? mapBooleanToInt(request === null || request === void 0 ? void 0 : request.isPaid)
                : void 0,
            skip: request === null || request === void 0 ? void 0 : request.skip,
            take: request === null || request === void 0 ? void 0 : request.take,
        },
        paramsSerializer: function (params) {
            return qs.stringify(params, { skipEmptyString: true });
        },
    })
        .then(function (_a) {
        var data = _a.data.data;
        return (__assign(__assign({}, data), { items: data.items.map(function (item) { return ({
                sum: item.sum,
                track: mapCatalogTrackObject(item.track),
            }); }) }));
    });
};
export var rightholderEarningsApi = {
    index: index,
};
